module.exports = __webpack_public_path__ + "static/media/52.dc31e61d.gif";